import { AccountOverlay } from '~domain/entities/AccountOverlay';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/AccountService';

export class AccountSidebarVisibilityUseCase {
    private isOpen: boolean;
    private overlay: AccountOverlay;

    constructor(isOpen: boolean) {
        this.isOpen = isOpen;
        this.overlay = diContainer.get(serviceNames.accountOverlay);
    }

    public execute() {
        this.overlay.setVisibility(this.isOpen);
    }
}
